var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgC3Icon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_29636_344481",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_29636_344481)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.4141 29.7632L30.8136 22.3307L29.3307 20.8566L23.4141 26.7732L21.0649 24.4141L19.5649 25.9141L23.4141 29.7632ZM12.2836 24.5807H16.0445V22.2836H12.2836V24.5807ZM12.2836 19.3778H22.7111V17.2836H12.2836V19.3778ZM12.2836 14.3778H22.7111V12.2836H12.2836V14.3778ZM20.0003 35.8307C17.8217 35.8307 15.7707 35.4152 13.8474 34.5841C11.9241 33.753 10.245 32.6205 8.81031 31.1866C7.37587 29.7524 6.24281 28.0741 5.41115 26.1516C4.57976 24.2291 4.16406 22.1786 4.16406 20.0003C4.16406 17.8103 4.57962 15.7518 5.41073 13.8249C6.24184 11.898 7.37434 10.2218 8.80823 8.79656C10.2424 7.37128 11.9207 6.24281 13.8432 5.41115C15.7657 4.57976 17.8161 4.16406 19.9945 4.16406C22.1845 4.16406 24.243 4.57962 26.1699 5.41073C28.0968 6.24184 29.773 7.36976 31.1982 8.79448C32.6235 10.2192 33.752 11.8946 34.5836 13.8207C35.415 15.7468 35.8307 17.8048 35.8307 19.9945C35.8307 22.1731 35.4152 24.2241 34.5841 26.1474C33.753 28.0707 32.625 29.7498 31.2003 31.1845C29.7756 32.6189 28.1002 33.752 26.1741 34.5836C24.248 35.415 22.19 35.8307 20.0003 35.8307Z",
    fill: "#1C1B1F"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgC3Icon);
export default __webpack_public_path__ + "static/media/c3Icon.fd454d249e06b56dee6c4dc4e400e114.svg";
export { ForwardRef as ReactComponent };